/**
 * The query every session read sends (`/auth/verify`, `/auth/sign-in`, the QR login status): leave the company's roster
 * out of `application.users`. The web app reads members and drivers from the team directory (`/team/*`). The server
 * honours it only for a company the directory serves (`featureFlags.teamDirectory`); any other company still gets the
 * roster, which the directory hooks fall back to. The key stays, as `[]`.
 */
export const OMIT_USERS_PARAMS = { omit: 'users' } as const
